import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "@ts-digital/vrc/es/components/modal";
import { PaymentPlanType } from "../../../PaymentContainerClient/commons/enums";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../CustomButton";
import "./style.css";

const fm = getFormattedMessageWithScope("components.PaymentSolutionsModal");

interface PaymentSolutionsModalProps {
    visible: boolean;
    onConfirm: Function;
    onAbort: Function;
    hasSelectedExpiredInstallments: boolean;
    isPayNow: boolean;
    selectedPaymentPlanType?: PaymentPlanType;
}

export const PaymentSolutionsModal = ({
    visible,
    onConfirm,
    onAbort,
    hasSelectedExpiredInstallments,
    isPayNow,
    selectedPaymentPlanType = PaymentPlanType.SingleInstallment,
}: PaymentSolutionsModalProps) => {
    const payOnDeadlineModalConfig = {
        [PaymentPlanType.SingleInstallment]: {
            title: fm("paySingleInstallmentPlanOnDeadlineTitle"),
            line1: fm("paySingleInstallmentPlanOnDeadlineLine1"),
            line2: fm("paySingleInstallmentPlanOnDeadlineLine2"),
            line3: undefined,
            confirmButton: fm("confirm"),
        },
        [PaymentPlanType.MultipleInstallments]: {
            title: fm("payMultipleInstallmentsPlanOnDeadlineTitle"),
            line1: fm("payMultipleInstallmentsPlanOnDeadlineLine1"),
            line2: fm("payMultipleInstallmentsPlanOnDeadlineLine2"),
            line3: fm("payMultipleInstallmentsPlanOnDeadlineLine3"),
            confirmButton: fm("next"),
        },
    };

    return (
        <Modal
            className="c-PaymentSolutionsModal"
            visible={visible}
            title={
                isPayNow
                    ? fm("payNowTitle")
                    : payOnDeadlineModalConfig[selectedPaymentPlanType].title
            }
            onClose={onAbort}
            footer={
                <div className="c-PaymentSolutionsModal-footer">
                    <div className="c-PaymentSolutionsModal-footer-buttons">
                        <CustomButton
                            kind="secondary"
                            colorScheme="ghost"
                            className="c-PaymentSolutionsModal-footer-buttons-abort"
                            onClick={onAbort}
                        >
                            {fm("abort")}
                        </CustomButton>
                        <CustomButton kind="primary" onClick={onConfirm}>
                            {isPayNow
                                ? fm("confirm")
                                : payOnDeadlineModalConfig[
                                      selectedPaymentPlanType
                                  ].confirmButton}
                        </CustomButton>
                    </div>
                </div>
            }
        >
            <div className="c-PaymentSolutionsModal-content">
                {isPayNow
                    ? fm("payNowLine1")
                    : payOnDeadlineModalConfig[selectedPaymentPlanType].line1}
                <p className="c-PaymentSolutionsModal-content-secondLine">
                    {isPayNow
                        ? fm("payNowLine2")
                        : payOnDeadlineModalConfig[selectedPaymentPlanType]
                              .line2}
                </p>
                {payOnDeadlineModalConfig[selectedPaymentPlanType].line3 &&
                !isPayNow ? (
                    <p className="c-PaymentSolutionsModal-content-thirdLine">
                        {
                            payOnDeadlineModalConfig[selectedPaymentPlanType]
                                .line3
                        }
                    </p>
                ) : undefined}
                {hasSelectedExpiredInstallments && !isPayNow ? (
                    <p className="c-PaymentSolutionsModal-content-expiredInstallmentsInfo">
                        <FontAwesomeIcon icon={faInfoCircle as IconProp} />{" "}
                        {fm("expiredInstallmentsInfo")}
                    </p>
                ) : undefined}
            </div>
        </Modal>
    );
};
